import { ParseTree } from '@mode-switch/express';
import { Attrs } from './Pipeline/Attrs';
import { CallNames } from './Pipeline/CallNames';
import { DataPaths } from './Pipeline/DataPaths';
import { DataRoles } from './Pipeline/DataRoles';
import { DataTypes } from './Pipeline/DataTypes';
import { ExprCalls } from './Pipeline/ExprCalls';
import { ExprNodes } from './Pipeline/ExprNodes';
import { ExprStages } from './Pipeline/ExprStages';
export var Resolver;
(function (Resolver) {
    function make(catalog, model, viewName, exprEnv) {
        return ParseTree.pipeline([
            DataPaths.make(),
            Attrs.make(catalog, model, viewName, exprEnv),
            CallNames.make(catalog),
            DataTypes.make(catalog),
            DataRoles.make(catalog),
            ExprCalls.make(catalog, model, viewName, exprEnv),
            ExprStages.make(catalog),
            ExprNodes.make(catalog),
        ]);
    }
    Resolver.make = make;
    function resolve(pipeline, tree, visitor) {
        return ParseTree.Pipeline.visit(pipeline, tree, visitor);
    }
    Resolver.resolve = resolve;
})(Resolver || (Resolver = {}));
